import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/components/ui/tooltip";
import React from "react";

import { Input } from "@/components/ui/input";
import { cn } from "@/lib/utils";

export const AccountNoInputCell = ({
  value,
  tooltip,
  saveHandler,
  prefix,
  className,

  key,
}: {
  value: any;
  tooltip?: string;
  key: string;
  prefix?: string;
  saveHandler: (value: string) => Promise<any>;
  className?: string;
}) => {
  const [text, setText] = React.useState(value);
  const onChange = (value: string) => {
    setText(value);
  };
  const onBlur = async () => {
    await saveHandler(text);
  };

  return tooltip ? (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger
          className={cn(
            "overflow-hidden text-ellipsis pt-2.5 pb-2.5  overflow-hidden w-full",
          )}
        >
          <div>{prefix}</div>
          <TableTextInput
            className={className}
            key={key}
            value={text}
            onChange={onChange}
            onBlur={onBlur}
          />
        </TooltipTrigger>
        <TooltipContent>{tooltip}</TooltipContent>
      </Tooltip>
    </TooltipProvider>
  ) : (
    <div
      className={cn(
        "overflow-hidden justify-start flex items-center text-ellipsis pt-2.5 pb-2.5 overflow-hidden w-full",
      )}
    >
      <div className="text-xs font-semibold ml-2 mr-1 w-5">{prefix}</div>
      <TableTextInput
        key={key}
        value={text}
        onChange={onChange}
        onBlur={onBlur}
        className={className}
      />
    </div>
  );
};

function TableTextInput({
  key,
  value,
  onChange,
  onBlur,
  className,
}: {
  key: string;
  value: string;
  onChange: (value: string) => void;
  onBlur: () => void;
  className?: string;
}) {
  return (
    <Input
      key={key}
      type="text"
      className={cn(
        "text-left font-normal text-sm rounded bg-transparent overflow-hidden text-ellipsis pl-0 ml-0",
        className,
      )}
      value={value}
      style={{
        border: "none",
        outline: "none",
      }}
      onChange={(e) => onChange(e.target.value)}
      onBlur={onBlur}
    />
  );
}
